<div class="modal">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Error</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button (click)="onClose()" type="button" class="modal__close">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="modal__cont">
    <p>An error occurred attempting to load the page. Please press the button below to refresh the page!</p>
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button (click)="refreshBrowser()" type="button" class="button">Refresh Page</button>
      </div>
    </div>
  </div>
</div>
